import { useState, useEffect } from 'react';

/**
 * Hook to track app visibility.
 * 
 * Returns a boolean indicating whether the app is currently in the foreground (visible)
 * or background (hidden).
 * 
 * @example
 * ```tsx
 * const { isForeground } = useAppForeground();
 * 
 * return (
 *   <div>
 *     {isForeground ? "App is visible" : "App is hidden"}
 *   </div>
 * );
 * ```
 */
export function useAppForeground() {
  const [isForeground, setIsForeground] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsForeground(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { isForeground };
} 